export default {
  "flash-message-wrapper": "_flash-message-wrapper_1qjhey"
};
